import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';

import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import UpdatesPage from 'js/src/components/public-pages/UpdatesPage';
import { getUpdatesPageRootReducer } from 'js/src/entry-points/root-reducers/updates-page-reducers';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { createReduxStore, renderWithRedux } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const UpdatesPageContainer = React.memo(function UpdatesPageContainer() {
    return (
        <PublicPagesTrim>
            <UpdatesPage />
        </PublicPagesTrim>
    );
});

const store = createReduxStore(getUpdatesPageRootReducer());
renderWithRedux(UpdatesPageContainer, store);
